var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React, { useEffect } from "react";
import useSessionReplayCore from "../../../../hooks/useSessionReplayCore";
import { MAX_RECORDING_TIME } from "../../../../constants";
import { RecordingStatus } from "../..";
import { saveSessionLink, updateSessionLink } from "./service";
import useExperiments from "../../../../hooks/useExperiments";
import { incrementNumOfSessionsRecordedToday } from "../../hooks";
import useWindowPath from "../../../../hooks/useWindowPath";
import useGeneralConfigs from "../../../../hooks/useGeneralConfigs";
const PassiveRecorder = (props) => {
  var _a;
  const { recordingStatus, setRecordingStatus } = props;
  const [secondsRecorded, setSecondsRecorded] = React.useState(0);
  const {
    record,
    stopRecording: stopSessionRecording,
    recordingMetaInfo,
    dumpBlackboxRecording,
    startBlackboxRecording
  } = useSessionReplayCore();
  const { activeExperiments } = useExperiments();
  const { uid, userCountry, btm, teaSessionId } = useGeneralConfigs();
  const path = useWindowPath();
  const largestSessionRecordingTime = Math.max(
    ...(_a = activeExperiments == null ? void 0 : activeExperiments.map((experiment) => {
      var _a2;
      return (_a2 = experiment.maxSessionDurationMinutes) != null ? _a2 : 0 * 60;
    })) != null ? _a : []
  );
  const maxRecordingTime = largestSessionRecordingTime <= 0 ? MAX_RECORDING_TIME : largestSessionRecordingTime;
  const timerInterval = React.useRef();
  const startTimer = () => {
    timerInterval.current = setInterval(() => {
      setSecondsRecorded((prev) => prev + 1);
    }, 1e3);
  };
  const stopTimer = () => {
    clearInterval(timerInterval.current);
  };
  const stopRecording = React.useCallback(() => __async(void 0, null, function* () {
    yield stopSessionRecording();
    setRecordingStatus(RecordingStatus.AUTHORISED_TO_RECORD);
  }), [setRecordingStatus, stopSessionRecording]);
  const startRecording = React.useCallback(
    (experimentIds) => __async(void 0, null, function* () {
      var _a2, _b;
      setRecordingStatus(RecordingStatus.STARTING_RECORDING);
      setSecondsRecorded(0);
      const recordingId = yield record();
      if (recordingId) {
        const saveSessionRes = saveSessionLink(
          {
            sessionId: recordingId,
            userId: uid,
            path: [window.location.pathname],
            countryCode: userCountry != null ? userCountry : "",
            experimentIds,
            startTime: Date.now() + "",
            teaSessionId: teaSessionId != null ? teaSessionId : (_b = (_a2 = window == null ? void 0 : window.Tea) == null ? void 0 : _a2.sessionManager) == null ? void 0 : _b.getSessionId()
          },
          userCountry != null ? userCountry : "sg"
        );
        if ((yield saveSessionRes).status === 200) {
          incrementNumOfSessionsRecordedToday();
          startTimer();
          setRecordingStatus(RecordingStatus.RECORDING);
        } else {
          stopRecording();
          setRecordingStatus(RecordingStatus.AUTHORISED_TO_RECORD);
        }
      } else {
        stopRecording();
        setRecordingStatus(RecordingStatus.AUTHORISED_TO_RECORD);
      }
    }),
    [setRecordingStatus, stopRecording, record, path, btm, activeExperiments]
  );
  const updateRecording = React.useCallback(
    (experimentIds) => __async(void 0, null, function* () {
      var _a2;
      setRecordingStatus(RecordingStatus.UPDATING_RECORDING);
      yield updateSessionLink(
        {
          sessionId: (_a2 = recordingMetaInfo == null ? void 0 : recordingMetaInfo.id) != null ? _a2 : "",
          addPath: [window.location.pathname],
          experimentIds
        },
        userCountry != null ? userCountry : ""
      );
      setRecordingStatus(RecordingStatus.RECORDING);
    }),
    [recordingMetaInfo == null ? void 0 : recordingMetaInfo.id, setRecordingStatus]
  );
  const handleEndRecording = () => __async(void 0, null, function* () {
    stopTimer();
    stopRecording();
  });
  useEffect(() => {
    if (secondsRecorded === maxRecordingTime) {
      handleEndRecording();
    }
  }, [secondsRecorded, maxRecordingTime]);
  useEffect(() => {
    var _a2, _b, _c, _d;
    console.log("[SR] Experiments Inside Recorder", activeExperiments, recordingStatus);
    const activeResearchExperimentsIds = (_b = (_a2 = activeExperiments == null ? void 0 : activeExperiments.filter((experiment) => {
      var _a3, _b2;
      return !((_a3 = experiment.blackBoxTriggers) == null ? void 0 : _a3.length) && !((_b2 = experiment.journeyEntryPage) == null ? void 0 : _b2.length);
    })) == null ? void 0 : _a2.map((experiment) => experiment.experimentId.toString())) != null ? _b : [];
    const activeJourneyEntryExperimentsIds = (_d = (_c = activeExperiments == null ? void 0 : activeExperiments.filter((experiment) => {
      var _a3;
      return (_a3 = experiment.journeyEntryPage) == null ? void 0 : _a3.length;
    })) == null ? void 0 : _c.map((experiment) => experiment.experimentId.toString())) != null ? _d : [];
    if (recordingStatus === RecordingStatus.RECORDING || recordingStatus === RecordingStatus.STARTING_RECORDING || recordingStatus === RecordingStatus.UPDATING_RECORDING) {
      if ((activeResearchExperimentsIds == null ? void 0 : activeResearchExperimentsIds.length) || (activeJourneyEntryExperimentsIds == null ? void 0 : activeJourneyEntryExperimentsIds.length)) {
        updateRecording([...activeResearchExperimentsIds, ...activeJourneyEntryExperimentsIds]);
      } else {
        stopRecording();
      }
    } else {
      if (activeExperiments == null ? void 0 : activeExperiments.length) {
        startRecording([...activeResearchExperimentsIds, ...activeJourneyEntryExperimentsIds]);
      }
    }
  }, [activeExperiments]);
  return null;
};
var passive_recorder_default = PassiveRecorder;
export {
  PassiveRecorder,
  passive_recorder_default as default
};
